'use client';

import React from 'react';
import { Button } from '@ui';

interface LanguageToggleProps {
  isSpanish?: boolean;
  onToggle?: () => void;
  ariaLabelEn?: string;
  ariaLabelEs?: string;
  labelEn?: string;
  labelEs?: string;
  disabled?: boolean;
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({
  isSpanish = false,
  onToggle,
  ariaLabelEn = 'Switch to English',
  ariaLabelEs = 'Cambiar a Español',
  labelEn = 'EN',
  labelEs = 'ES',
  disabled = false,
}) => {
  return (
    <Button
      className='toggle-btn'
      as='button'
      type='button'
      aria-label={isSpanish ? ariaLabelEn : ariaLabelEs}
      onClick={onToggle}
      label={isSpanish ? labelEn : labelEs}
      disabled={disabled}
    />
  );
};

export type { LanguageToggleProps };
export default LanguageToggle;
